<div id="containerLeftMenu" style="margin-right: 15px">
    <section id="column1">
        @if (profileMenu) {
            <nav id="left-nav" class="row" aria-label="Profile">
                <div class="col">
                    <h4>Profile</h4>
                    <ul>
                        <li><a routerLink="/user-guide" routerLinkActive="active">User Guide</a></li>
                        <li><a routerLink="/pat-setup" routerLinkActive="active">PAT Setup</a></li>
                    </ul>
                </div>
            </nav>
        } @else {
            <np-menu [location]="NavigationLocation.Side"></np-menu>
        }
    </section>
</div>